import React, { useEffect } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';

interface Props {
  children: React.ReactNode;
}

const lightTokens = {
  colorPrimary: '#C2410C',
  borderRadius: 12,
  colorBgContainer: '#FFFFFF',
  colorBgLayout: '#FAFAF8',
  colorBgElevated: '#FFFFFF',
  colorBorder: '#ECE8E1',
  colorText: '#18181B',
  colorTextSecondary: '#3F3F46',
  fontFamily: "'Satoshi', system-ui, -apple-system, sans-serif",
  colorLink: '#18181B',
};

export const StorefrontThemeProvider: React.FC<Props> = ({ children }) => {
  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', 'light');
    root.style.colorScheme = 'light';
    document.body.setAttribute('data-theme', 'light');
  }, []);

  return (
    <ConfigProvider
      theme={{
        algorithm: antdTheme.defaultAlgorithm,
        token: lightTokens,
        components: {
          Layout: {
            headerBg: '#FAFAF8',
            bodyBg: '#FAFAF8',
            footerBg: '#FAFAF8',
          },
          Card: {
            colorBgContainer: '#FFFFFF',
          },
          Input: {
            colorBgContainer: '#FFFFFF',
            activeBorderColor: '#C2410C',
          },
          Button: {
            controlHeightLG: 44,
          },
        },
      }}
    >
      <div
        style={{
          backgroundColor: 'var(--color-paper)',
          minHeight: '100dvh',
          color: 'var(--color-ink)',
          transition:
            'background-color var(--duration-normal) var(--ease-out), color var(--duration-normal) var(--ease-out)',
        }}
      >
        {children}
      </div>
    </ConfigProvider>
  );
};

export default StorefrontThemeProvider;
